import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { Text } from "react_reusable_components";
import Styles from "./QuestionnaireListingContainer.module.scss";
import { userRole } from "../../constants";

export const columns = (intl, isMd, authState) =>
  [
    {
      dataIndex: "name",
      key: "name",
      width: !isMd && "20%",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "questionnaire.tableHeader.name")}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text}
        </Text>
      ),
    },
    {
      dataIndex: "isOperational",
      key: "type",
      width: "20%",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(intl, "questionnaire.tableHeader.type")}{" "}
        </Text>
      ),
      render: (text, record) => (
        <div>
          <Text
            type="secondary"
            className={`${Styles["text-style"]} ${Styles["no-capitalize"]}`}
          >
            {text ? "Operational" : "Repair"}
          </Text>
          {record?.isPrimary && (
            <div
              type="secondary"
              className={`${Styles["text-primary-style"]} ${Styles["no-capitalize"]}`}
            >
              {getLocalizedMessage(intl, "viewQuestionnaire.text.primary")}
            </div>
          )}
        </div>
      ),
    },
    isMd && {
      dataIndex: "productCategory",
      key: "productCategory",
      title: (
        <Text className={Styles["header-text"]}>
          {getLocalizedMessage(
            intl,
            authState?.currentRole?.id === userRole.ADMIN
              ? "questionnaire.tableHeader.productCategory"
              : "questionnaire.tableHeader.assignedProductCategory"
          )}
        </Text>
      ),
      render: (text) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {text?.name || "-"}
        </Text>
      ),
    },
    isMd && {
      dataIndex: "productSubCategory",
      key: "productSubCategory",
      title: (
        <Text className={Styles["header-text"]}>
          {authState?.currentRole?.id === userRole.ADMIN
            ? getLocalizedMessage(
                intl,
                "questionnaire.tableHeader.subProductCategory"
              )
            : getLocalizedMessage(
                intl,
                "questionnaire.tableHeader.assignedSubProductCategory"
              )}
        </Text>
      ),
      render: (productSubCategory) => (
        <Text type="secondary" className={Styles["text-style"]}>
          {productSubCategory?.name || "-"}
        </Text>
      ),
    },
  ].filter((item) => item);
